import { DomainView } from "@/components/domain";
import { useSheetContext } from "@/context/sheet";
import { useDeleteRegion, useGetRegion } from "@/hooks/regions";
import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { Key } from "react";

export const Route = createFileRoute("/(regions)/regions/_sheet/$id/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  const { data, isLoading } = useGetRegion(id);
  const { close } = useSheetContext();
  const navigate = useNavigate();
  const { mutate: deleteRegion } = useDeleteRegion({
    onSuccess: () => {
      close(() => {
        navigate({ to: "/regions" });
      });
    },
  });

  return (
    <DomainView
      domain="regions"
      editLink={(children, key) => (
        <Link to="/regions/$id/edit" params={{ id }} key={key as Key}>
          {children}
        </Link>
      )}
      isLoading={isLoading}
      title={data?.name}
      onDelete={() => deleteRegion(id)}
      propsList={[
        {
          title: "regions.fields.color",
          value: data?.color ? (
            <div
              className="aspect-square w-5"
              style={{ backgroundColor: data.color }}
            />
          ) : (
            "-"
          ),
        },
        {
          title: "regions.fields.description",
          value: data?.description ?? "-",
        },
      ]}
    />
  );
}
